import React from "react";
import LegalLayout, { Section } from "@/pages/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026" testid="terms-page">
      <Section title="1. What AutoGridSocial is">
        <p>
          AutoGridSocial (operated by Beckett LLC) is a B2B Software-as-a-Service (SaaS) productivity tool
          designed for content organization, AI-assisted post generation, and social media scheduling. By creating
          an account you agree to these Terms of Service.
        </p>
      </Section>
      <Section title="2. Acceptable use & prohibited services">
        <p>
          AutoGridSocial strictly provides software tools for content creation and scheduling. We do <strong>NOT</strong>{" "}
          sell social media followers, likes, engagement, views, or any form of automated scraping services. You agree
          not to use the platform to violate the terms of any third-party social network, to post unlawful, deceptive,
          or infringing content, or to attempt to reverse-engineer or resell the service.
        </p>
      </Section>
      <Section title="3. Subscriptions & billing">
        <p>
          AutoGridSocial offers a <strong>Pro subscription at $29/month</strong> and a one-time
          <strong> $10 credit pack</strong> (3 campaigns). Pro is charged at checkout and renews automatically each month
          until cancelled — there is <strong>no trial or setup fee</strong>. The credit pack is a single one-time charge
          that does not renew.
        </p>
        <p>
          Subscriptions renew automatically each billing period until cancelled. All fees are
          processed securely by Stripe. Prices are stated exclusive of any applicable taxes.
        </p>
      </Section>
      <Section title="4. Cancellation">
        <p>
          You may cancel at any time from your account's Billing page or through the Stripe customer portal.
          Cancellation stops future renewals; you retain access until the end of the current paid period. See our{" "}
          Refund &amp; Cancellation Policy for details.
        </p>
      </Section>
      <Section title="5. Content ownership">
        <p>
          You retain ownership of the content you input and the posts you generate. You grant us a limited license to
          process that content solely to provide the service (e.g., generating and scheduling posts on your behalf).
        </p>
      </Section>
      <Section title="6. Disclaimers & liability">
        <p>
          The service is provided "as is" without warranties of any kind. To the maximum extent permitted by law,
          Beckett LLC is not liable for indirect, incidental, or consequential damages arising from use of the
          service. Your sole remedy for dissatisfaction is to cancel your subscription.
        </p>
      </Section>
      <Section title="7. Changes to these terms">
        <p>
          We may update these Terms from time to time. Material changes will be communicated via email or in-app
          notice. Continued use after changes take effect constitutes acceptance.
        </p>
      </Section>
    </LegalLayout>
  );
}
